import React, { useEffect, useState } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";

export function AssignRfidDialog({
	visible,
	onHide,
	onAssign,
	uid
}: {
	uid: string,
	visible: boolean;
	onHide: () => void;
	onAssign: (uid: string, emaid: string) => Promise<void> | void;
}) {
	const [emaid, setEmaid] = useState<string>("");
	const [loading, setLoading] = useState<boolean>(false);

	useEffect(() => {
		if (!visible) {
			setEmaid("");
		}
	}, [visible]);

	const footer = (
		<div>
			<Button label="Cancel" icon="pi pi-times" onClick={onHide} className="p-button-text" />
			<Button
				label="Submit"
				icon="pi pi-user-plus"
				onClick={async () => {
					setLoading(true);
					try {
						await onAssign(uid, emaid);
					} finally {
						setLoading(false);
					}
				}}
				loading={loading}
				autoFocus
			/>
		</div>
	);

	return (
		<Dialog
			header="Assign RFID Card to owner"
			visible={visible}
			style={{ width: "30rem" }}
			onHide={onHide}
			footer={footer}
		>
			<p className="m-0 mb-4">Assign owner for card {uid}</p>
			<label htmlFor="emaid" className="block mb-2 text-lg ">
				Owner Emaid
			</label>
			<InputText id="emaid" className="block w-full" value={emaid} onChange={(e) => setEmaid(e.target.value)} />
		</Dialog>
	);
}